import { templatesSlice } from './templatesSlice';
import * as actions from './templatesActions';
import * as selectors from './templatesSelectors';

export { actions };
export { selectors };
export default templatesSlice.reducer;